import { observable, action } from 'mobx';
import { merge } from 'lodash';

export default class TrendsStore {
    @observable featuredPosts = [];
    @observable gridFeatures = [];
    @observable mainFeature = [];
    @observable post = {};
    @observable posts = [];
    @observable postsPaged = [];
    @observable redirectUrl = '';

    constructor(state) {
        merge(this, state);
    }

    @action
    redirectTo404() {
        this.redirectUrl = '/page-not-found';
    }

    @action
    clearRedirectUrl() {
        this.redirectUrl = '';
    }

    @action
    clearPost() {
        this.post = {};
    }

    @action
    loadFeaturedPostsSuccess(posts) {
        this.featuredPosts = posts.map(post => {
            post.blogPostUrlPath = post.blogPostUrlPath
                .toLowerCase()
                .replace(/_/g, '-');

            return post;
        });
        this.mainFeature = this.featuredPosts[0];
        this.gridFeatures = this.featuredPosts.slice(1);
    }

    @action
    loadPostsSuccess(posts) {
        this.posts = posts
            .map(post => {
                post.blogPostUrlPath = post.blogPostUrlPath
                    .toLowerCase()
                    .replace(/_/g, '-');

                return post;
            })
            .filter(post => !post.featuredPostDisplayOrder);

        this.setPagedPosts();
    }

    @action
    loadPostByUrlPathSuccess(post) {
        let newImgStyle = '<img style="max-width: 100%"';
        let newHtmlBody = post.htmlBody
            .replace(/<img/g, newImgStyle)
            .replace(/http:\/\//g, 'https://');
        post.htmlBody = newHtmlBody;

        this.post = post;
    }

    @action
    loadMorePosts() {
        const i = this.postsPaged.length;
        const nextPosts = this.posts.slice(i, i + 8);
        this.postsPaged.push(...nextPosts);
    }

    @action
    setPagedPosts() {
        this.postsPaged = this.posts.slice(0, 8);
    }

    @action
    resetOnServer() {
        this.featuredPosts = [];
        this.gridFeatures = [];
        this.mainFeature = [];
        this.post = {};
        this.posts = [];
        this.postsPaged = [];
        this.redirectUrl = '';
    }
}



// WEBPACK FOOTER //
// ./src/common/stores/TrendsStore.js